import { DialogEvents } from '@naturehouse/design-system/components/molecules/dialog/Dialog';
import { matchMediaAddEventListener } from '@naturehouse/nh-essentials/lib/polyfills/matchMedia';
import DialogHandler from '../../app/components/DialogHandler';
import GTM from '../../../gtm/GTM';
import type { GTMEventReturnType } from '../../../gtm/GTM.types';

export type DialogConfig = {
    buttonSelector: string;
    dialogSelector: string;
    eventModel?: {
        parseToGTMData: () => GTMEventReturnType;
    };
};

export default class ListingDialogHandler {
    public initialize(dialogConfigs: DialogConfig[]): void {
        dialogConfigs.forEach((config) => {
            this.#initializeDialog(config);
        });
    }

    readonly #initializeDialog = (config: DialogConfig): void => {
        const handler = new DialogHandler({
            buttonSelector: config.buttonSelector,
            dialogSelector: config.dialogSelector
        });

        handler.initialize();

        if (!handler.dialog) {
            return;
        }

        if (config.eventModel) {
            const eventModel = config.eventModel;
            handler.dialog.addEventListener(DialogEvents.OPENED, (): void => {
                GTM.track(eventModel.parseToGTMData());
            });
        }

        const mq: MediaQueryList = window.matchMedia('(min-width: 1024px)');

        matchMediaAddEventListener(mq, (e) => {
            if (e.matches) {
                handler.dialog?.close();
            }
        });
    };
}
